import type { BadgeVariant } from '../../components';
import type { UserSearchStatus } from '../../types/api';

export const USER_STATUS_BADGE: Record<
  UserSearchStatus,
  { label: string; variant: BadgeVariant }
> = {
  active: { label: 'Active', variant: 'success' },
  pending_verification: { label: 'Pending Verification', variant: 'warning' },
  invited: { label: 'Invited', variant: 'info' },
  inactive: { label: 'Inactive', variant: 'default' },
  blocked: { label: 'Blocked', variant: 'danger' },
};

export const getUserDisplayStatus = (params: {
  status?: string | null;
  isBlocked?: boolean;
}): UserSearchStatus | null => {
  if (params.isBlocked || params.status === 'blocked') {
    return 'blocked';
  }

  if (!params.status) {
    return null;
  }

  if (params.status in USER_STATUS_BADGE) {
    return params.status as UserSearchStatus;
  }

  return null;
};
